/**
 * The front door, for the session that holds both halves of this site. Somebody who holds one
 * lands on that half instead: a menu with one entry is a click that can only go one way.
 */
export const overzicht = {
  titel: "Overzicht",
  uitleg: "Seizoen {{naam}}. Kies wat je wilt doen.",
  geenSeizoen: "Er staat nog geen seizoen klaar.",
  terug: "Terug naar het overzicht",

  /** Holding neither half: say what is true rather than give instructions for an absent choice. */
  geenToegang:
    "Er staat op dit moment niets voor je klaar. Hieronder lees je waarom.",

  kaarten: {
    ploegen:
      "Schrijf de ploegen van je korps in voor de wedstrijddagen en geef je voorkeursdatums door.",
    beschikbaarheid: "Geef aan op welke wedstrijddagen je kunt ondersteunen.",
    planning:
      "Bekijk het speelschema: wanneer elke ploeg start en wie er op de wedstrijdbaan staat.",
  },
} as const;
